import { http } from "@/lib/http";
import { useToast } from "@/providers/toast.provider";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export function useRemoveOrder() {
  const queryClient = useQueryClient();
  const { toaster } = useToast();

  return useMutation({
    mutationFn: async (id: string) => {
      const res = await http.delete<{ success: boolean; message: string }>(
        `/orders/${id}`
      );
      return res.data;
    },

    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: ["sale", "me"] });
      toaster(data.message, "success");
    },

    onError: (error) => {
      toaster(error?.message ?? "Algo deu errado!", "error");
    },
  });
}
